import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/docs/otago-architecture.png")